// extracted by mini-css-extract-plugin
export var danger = "_3g-6";
export var lightPink = "_3g-a";
export var medium = "_3g-j";
export var nearSquare = "_3g-m";
export var neutralBlue = "_3g-8";
export var neutralYellow = "_3g-7";
export var noCapitalize = "_3g-1";
export var normal = "_3g-2";
export var pill = "_3g-0";
export var primary = "_3g-3";
export var primaryLight = "_3g-4";
export var shadow = "_3g-n";
export var small = "_3g-k";
export var solidBlack = "_3g-i";
export var solidGreen = "_3g-d";
export var solidLightBlue = "_3g-f";
export var solidNavy = "_3g-e";
export var solidOrange = "_3g-h";
export var solidPink = "_3g-g";
export var solidRed = "_3g-b";
export var solidWhite = "_3g-9";
export var solidYellow = "_3g-c";
export var success = "_3g-5";
export var xsmall = "_3g-l";